import styled from 'styled-components';

import {
  Button,
  Editor,
  InlineInput,
} from 'web-components';

import {
  Flex,
  SVG,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  spacing: 10,
  align: 'center',
  justify: 'space-between',
})`
  color: #fff;
  padding: 20px;
  margin: -1px -1px 0 -1px;
  width: calc(100% + 2px);
  background: ${props => props.theme.colors.primary};
  border-radius: 6px 6px 0 0;
  position: relative;
`;

export const Video = styled(Flex).attrs({
  width: '30%',
  column: true,
})`
  padding: 10px;
  min-width: 400px;
`;

export const TitleInput = styled(InlineInput)`
  color: ${props => props.theme.colors.primary};
  font-size: 1.6em;
  font-style: normal;
  font-weight: 600;
  word-break: initial;
  padding: 0;
  padding-left: 10px;
  margin-right: 10px;
  height: auto;
  border: 1px dashed transparent;
  box-shadow: none !important;
  background: none !important;

  &:hover,
  &:focus {
    border-color: ${props => props.theme.colors.primary};
  }

  @media print {
    color: #000;
    padding-left: 0;
    font-size: 25px;
  }
`;

export const Description = styled(Editor).attrs({
  isInline: true,
})`
  color: #2f3539;
  font-size: 14px;
  line-height: 18px;
  width: 100%;
  border: 1px dashed transparent;

  &:hover,
  &:focus {
    border-color: ${props => props.theme.colors.primary};
  }
`;

export const ContextMenu = styled(SVG.ContextMenu).attrs(
  props => ({
    width: 31,
    height: 28,
    stroke: props.theme.colors.primary,
  }),
)``;

export const Actions = styled(Button)`
  border: 1px solid ${props => props.theme.colors.primary};
  width: 30px;
  height: 30px;
  padding: 0;
  background: #fff !important;

  &:hover {
    opacity: 0.7;
  }

  @media print {
    border: none;
  }
`;
